import { getSurroundingPointsForNulls } from '@utils/chart-data.ts';
import experienceStatsStore from '@store/experience-stats-store.ts';
import { ExperienceStatType } from '@/enums/experience-stat-type.ts';
import { DataGranularity } from '@/enums/data-granularity.ts';

const ExperienceStatsMissingData = (props: {
	data: number[][];
	granularity: DataGranularity;
	experienceId: number;
	statType: ExperienceStatType;
	color: string;
	name: string;
}) => {
	const missingDataSeries: {
		name: string;
		color: string;
		data: (number | null)[][] | undefined;
	}[] = [];

	missingDataSeries.push({
		name: props.name,
		color: props.color,
		data: getSurroundingPointsForNulls(
			experienceStatsStore.experienceStat(
				props.experienceId,
				props.statType,
				props.granularity
			) ?? [],
			props.granularity
		),
	});

	return missingDataSeries;
};

export default ExperienceStatsMissingData;
